import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = 'Bearer ' + token;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  getProfile: () => api.get('/auth/profile')
};

export const clientAPI = {
  getAll: (search) => api.get('/clients', { params: { search } }),
  getById: (id) => api.get('/clients/' + id),
  create: (data) => api.post('/clients', data),
  update: (id, data) => api.put('/clients/' + id, data),
  delete: (id) => api.delete('/clients/' + id)
};

export const proposalAPI = {
  generate: (data) => api.post('/proposals/generate', data),
  save: (data) => api.post('/proposals', data),
  getAll: () => api.get('/proposals'),
  getById: (id) => api.get('/proposals/' + id),
  downloadPDF: (id) => api.get('/proposals/' + id + '/pdf', { responseType: 'blob' })
};

export const quotationAPI = {
  generate: (data) => api.post('/quotations/generate', data),
  checkConsistency: (data) => api.post('/quotations/check-consistency', data),
  save: (data) => api.post('/quotations', data),
  getAll: () => api.get('/quotations'),
  getById: (id) => api.get('/quotations/' + id),
  downloadPDF: (id) => api.get('/quotations/' + id + '/pdf', { responseType: 'blob' }),
  compare: (data) => api.post('/quotations/compare', data)
};

export const settingsAPI = {
  get: () => api.get('/settings'),
  update: (data) => api.post('/settings', data)
};

export default api;
